import { css } from 'linaria';

export const productCardsListSwiper = css`
  && {
    margin-bottom: 32px;

    @media (--only-tablet) {
      padding: 0;
      margin-right: 0;
      margin-left: 0;
    }

    > div {
      @media (--from-tablet) {
        flex-wrap: wrap;
        row-gap: 24px;
        column-gap: 40px;
      }
    }
  }
`;

export const productCardsListSlide = css`
  && {
    width: auto;

    @media (--only-mobile) {
      margin-right: 24px;
    }
  }
`;
